import { useState } from 'react';
import { IconCopy, IconCheck } from '@tabler/icons-react';
import { ActionIcon, type ActionIconProps } from './ActionIcon';

interface CopyToClipboardActionIconProps extends ActionIconProps {
    value: string;
}

export const CopyToClipboardActionIcon = ({ value, ...props }: CopyToClipboardActionIconProps) => {
    const [copySuccess, setCopySuccess] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
            setCopySuccess(true);

            // Reset the success state after a bit
            setTimeout(() => {
                setCopySuccess(false);
            }, 2000);
        } catch {
            setCopySuccess(false);
        }
    };

    return (
        <ActionIcon
            {...props}
            onClick={handleCopy}
            aria-label={'Copy to clipboard'}
            tooltip={copySuccess ? 'Copied! ✅' : 'Copy to clipboard'}
        >
            {copySuccess ? <IconCheck size={16} /> : <IconCopy size={16} />}
        </ActionIcon>
    );
};
